import React from 'react';
import { Toast, Announce, AlertVariant } from 'react-magma-dom';

export const TEST_ID = 'generic-error-message';

export interface ErrorMessageProps {
  errorMessage: string;
  onDismiss: any;
  isShown: boolean;

  variant?: AlertVariant;
  testId?: string;
}

export const ErrorMessage: React.FunctionComponent<ErrorMessageProps> = props => {
  const { variant = AlertVariant.warning, testId = TEST_ID } = props;
  return (
    <Announce>
      {props.isShown && (
        <Toast variant={variant} onDismiss={props.onDismiss} testId={testId}>
          {props.errorMessage}
        </Toast>
      )}
    </Announce>
  );
};
